module.exports = {"pageTitleText":"線路分組","recordLineGroupName":"分組名稱","createText":"添加線路分組"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/recordLineGroups.json
// module id = 62WY
// module chunks = 3